exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.hamburger[data-v-4e6f274c] {\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n  width: 20px;\r\n  height: 20px;\r\n  fill: #f4f4f5;\n}\n.hamburger.is-active[data-v-4e6f274c] {\r\n  -webkit-transform: rotate(180deg);\r\n          transform: rotate(180deg);\n}\r\n", ""]);

